module.exports = __webpack_public_path__ + "img/yt.4936ce16.svg";